import type { JSONValue } from "@glide/plugins";
import { asMaybeString } from "./computation-model/data";

export function formatJSON(value: JSONValue): string | undefined {
    if (value === null) return undefined;
    if (typeof value === "object") return JSON.stringify(value);

    return asMaybeString(value);
}
